import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-success-circle",
  "use": "ico-success-circle-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 35\" id=\"ico-success-circle\">\n  <circle id=\"ico-success-circle_Ellipse_124\" data-name=\"Ellipse 124\" cx=\"17.5\" cy=\"17.5\" r=\"17.5\" fill=\"#1ac94c\" />\n  <path id=\"ico-success-circle_Path_1397\" data-name=\"Path 1397\" d=\"M9123.348-3001.307l4.295,4.64,9.705-9.962\" transform=\"translate(-9112.848 3019.647)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol